import React, { useReducer } from "react";
import { BrowserRouter, HashRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import { reducer, initState } from "./reducer/AppState";
import Dashboard from "./components/Dashboard";
import Signup from "./components/Signup";
import Login from "./components/Login";
import AdminDashBoard from "./components/AdminDashBoard"
import Loading from "./components/Loading";
import ForgotPassword from "./components/ForgotPassword"
import PasswordReset from "./components/PasswordReset"

export const StateContext = React.createContext();

function App() {
  const [state, dispatch] = useReducer(reducer, initState);

  return (
    <StateContext.Provider value={{ state, dispatch }}>
      <HashRouter>
        <div className="App">
          <Loading />
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/signup" component={Signup} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route path="/password-reset" component={PasswordReset} />
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/admin-dashboard" component={AdminDashBoard} />
          </Switch>
        </div>
      </HashRouter>
    </StateContext.Provider>
  );
}

export default App;
